<template>
  <!-- 待支取费用报销 -->
  <div>
    <div class="home-pannel">
      <div class="home-pannel-title" style="display:flex;justify-content:space-between;">
        <span>待支取费用报销</span>
         <div @click="showMoreClick" class="moreText">查看更多</div>
      </div>
      <div class="home-pannel-content">
        <expenseReimVue :is-index-page="isIndexPage" style="padding: 10px;backgroundColor: #fff;height:100%;"/>
      </div>
    </div>
  </div>
</template>

<script>
import expenseReimVue from '@/views/financialManage/expenseReim/index.vue'
export default {
  components: {expenseReimVue},
  data () {
    return {
      isIndexPage: true
    }
  },
  mounted () {
  },
  methods: {
    showMoreClick () {
      this.$router.push({path: 'financialManage/expenseReim', query: {drawStatus: 0, checkStatus: 2}})
    }
  }
}
</script>

<style lang="less" scoped>
.right-content{
  margin-top: 20px;
}
  .jineValue{
    color:#4b9de1;
    font-size: 20px;
    font-weight: bold;
  }
    .moreText{
    cursor: pointer;
    height: 30px;
    padding: 0 6px;
    border:1px solid #e1e1e1;
    border-radius:20px;
    margin-top: 10px;
    margin-right: 10px;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
  }
    .moreText:hover{
      background-color: #e9e9e9;
    }
</style>



// WEBPACK FOOTER //
// src/components/homeComponents/expenseReimInfo.vue